<router-outlet></router-outlet>
<bnt-modals />
